// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ThemeSetterContainer {
    background-color: rgba(0, 0, 0, 0.5);
    width: 100%;
    height: 100vh;
    position: fixed;
    top: 0;
    right: 0;
    z-index: 3;
}

.ThemeSetterContainerCard{
    float: right;
    height: 100vh;
    color: #333; /* Default text color */
    background-color: #fff; /* Default background color */
    width: 400px;
}
.ThemeSetterContainerCard>div>label{
    margin-left: 0.5rem; /* Equivalent to ml-2 in Tailwind */
    font-size: 1rem; /* Equivalent to text-md in Tailwind */
    cursor: pointer;
}
.ThemeSetterContainerCardB1{
    display: flex; /* Equivalent to flex in Tailwind */
    justify-content: space-between; /* Equivalent to justify-between in Tailwind */
    align-items: center; /* Equivalent to items-center in Tailwind */
    padding: 1rem; /* Equivalent to p-4 in Tailwind */
    margin-left: 1rem; /* Equivalent to ml-4 in Tailwind */
}
.CancelBtn{
    font-size: 2rem; 
    color:var(--primary_color); 
    padding: .5rem; 
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: transparent;
    transition: all 1s;

}
.CancelBtn:hover{
    box-shadow: 0 2px 8px rgba(0, 0, 0, .4); 
    background-color: white;
    
}
.ThemeSetterContainerCardB2{
    display: flex; /* Equivalent to flex-col in Tailwind */
    flex-direction: column; /* Equivalent to flex-col in Tailwind */
    border-top: 1px solid #ccc; /* Equivalent to border-t-1 border-color in Tailwind */
    padding: 1rem; /* Equivalent to p-4 in Tailwind */
    margin-left: 1rem; /* Equivalent to ml-4 in Tailwind */
}
.ThemeSetterContainerCardB2>div{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row-reverse;
    gap: 2rem;
    padding: .5rem;
}

.customColors{
    display: flex;
    flex-direction: column !important;
    justify-content: flex-start;
    align-items: flex-start;
}
.customColors>div{
    display: flex;
    gap:2rem;
    justify-content: space-between;
    align-items: flex-start;
    width: 50%;
}`, "",{"version":3,"sources":["webpack://./src/Components/ImpactPageComponents/Themesetter/ThemeSetting.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;IACpC,WAAW;IACX,aAAa;IACb,eAAe;IACf,MAAM;IACN,QAAQ;IACR,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,WAAW,EAAE,uBAAuB;IACpC,sBAAsB,EAAE,6BAA6B;IACrD,YAAY;AAChB;AACA;IACI,mBAAmB,EAAE,mCAAmC;IACxD,eAAe,EAAE,sCAAsC;IACvD,eAAe;AACnB;AACA;IACI,aAAa,EAAE,mCAAmC;IAClD,8BAA8B,EAAE,8CAA8C;IAC9E,mBAAmB,EAAE,2CAA2C;IAChE,aAAa,EAAE,kCAAkC;IACjD,iBAAiB,EAAE,mCAAmC;AAC1D;AACA;IACI,eAAe;IACf,0BAA0B;IAC1B,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,6BAA6B;IAC7B,kBAAkB;;AAEtB;AACA;IACI,uCAAuC;IACvC,uBAAuB;;AAE3B;AACA;IACI,aAAa,EAAE,uCAAuC;IACtD,sBAAsB,EAAE,uCAAuC;IAC/D,0BAA0B,EAAE,sDAAsD;IAClF,aAAa,EAAE,kCAAkC;IACjD,iBAAiB,EAAE,mCAAmC;AAC1D;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,2BAA2B;IAC3B,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,iCAAiC;IACjC,2BAA2B;IAC3B,uBAAuB;AAC3B;AACA;IACI,aAAa;IACb,QAAQ;IACR,8BAA8B;IAC9B,uBAAuB;IACvB,UAAU;AACd","sourcesContent":[".ThemeSetterContainer {\n    background-color: rgba(0, 0, 0, 0.5);\n    width: 100%;\n    height: 100vh;\n    position: fixed;\n    top: 0;\n    right: 0;\n    z-index: 3;\n}\n\n.ThemeSetterContainerCard{\n    float: right;\n    height: 100vh;\n    color: #333; /* Default text color */\n    background-color: #fff; /* Default background color */\n    width: 400px;\n}\n.ThemeSetterContainerCard>div>label{\n    margin-left: 0.5rem; /* Equivalent to ml-2 in Tailwind */\n    font-size: 1rem; /* Equivalent to text-md in Tailwind */\n    cursor: pointer;\n}\n.ThemeSetterContainerCardB1{\n    display: flex; /* Equivalent to flex in Tailwind */\n    justify-content: space-between; /* Equivalent to justify-between in Tailwind */\n    align-items: center; /* Equivalent to items-center in Tailwind */\n    padding: 1rem; /* Equivalent to p-4 in Tailwind */\n    margin-left: 1rem; /* Equivalent to ml-4 in Tailwind */\n}\n.CancelBtn{\n    font-size: 2rem; \n    color:var(--primary_color); \n    padding: .5rem; \n    border-radius: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: transparent;\n    transition: all 1s;\n\n}\n.CancelBtn:hover{\n    box-shadow: 0 2px 8px rgba(0, 0, 0, .4); \n    background-color: white;\n    \n}\n.ThemeSetterContainerCardB2{\n    display: flex; /* Equivalent to flex-col in Tailwind */\n    flex-direction: column; /* Equivalent to flex-col in Tailwind */\n    border-top: 1px solid #ccc; /* Equivalent to border-t-1 border-color in Tailwind */\n    padding: 1rem; /* Equivalent to p-4 in Tailwind */\n    margin-left: 1rem; /* Equivalent to ml-4 in Tailwind */\n}\n.ThemeSetterContainerCardB2>div{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: row-reverse;\n    gap: 2rem;\n    padding: .5rem;\n}\n\n.customColors{\n    display: flex;\n    flex-direction: column !important;\n    justify-content: flex-start;\n    align-items: flex-start;\n}\n.customColors>div{\n    display: flex;\n    gap:2rem;\n    justify-content: space-between;\n    align-items: flex-start;\n    width: 50%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
